import React, { forwardRef } from 'react';
import { string, bool, node } from 'prop-types';
import ClassNames from 'classnames';

import './SelectValue.scss';

const SelectValue = forwardRef((props, ref) => {
  const { disabled, id, invalid, label, name, prefix, readOnly, value } = props;

  const componentClassNames = ClassNames(
    'select-value',
    value === null && `select-value--placeholder`,
    disabled && 'select-value--disabled',
    invalid && `select-value--invalid`
  );

  const displayedLabel = readOnly && value === '' ? '' : label;

  return (
    <div ref={ref} className={componentClassNames}>
      {!!prefix && (
        <div className="select-value__prefix-container">{prefix}</div>
      )}
      <div className="select-value__content">{displayedLabel}</div>
      <input id={id} name={name} type="hidden" value={value} />
    </div>
  );
});

SelectValue.propTypes = {
  disabled: bool.isRequired,
  id: string,
  invalid: bool.isRequired,
  label: string.isRequired,
  name: string,
  prefix: node,
  readOnly: bool.isRequired,
  value: string.isRequired
};

SelectValue.defaultProps = {
  id: '',
  name: '',
  prefix: undefined
};

export default SelectValue;
